import { render, staticRenderFns } from "./tappingdialog.vue?vue&type=template&id=5ed0dc3b&"
import script from "./../../ts/dialog/tappingdialog.ts?vue&type=script&lang=js&"
export * from "./../../ts/dialog/tappingdialog.ts?vue&type=script&lang=js&"
import style0 from "./../../assets/css/tappingdialog.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports